
document.addEventListener('DOMContentLoaded', function() {
  var header = document.querySelector('.site-header');
  if (!header) return;

  var logo = document.querySelector('.site-header__logo');

  function clearHeaderClasses() {
    header.classList.remove(
      'submenu-bg-1', 'submenu-bg-2', 'submenu-bg-3', 'submenu-bg-4', 'submenu-bg-5',
      'submenu-text-light', 'submenu-text-dark'
    );

    if (logo) {
      logo.classList.remove('is-light');
    }
  }

  var navItems = document.querySelectorAll(
    '.site-nav__item.submenu-bg-1, ' +
    '.site-nav__item.submenu-bg-2, ' +
    '.site-nav__item.submenu-bg-3, ' +
    '.site-nav__item.submenu-bg-4, ' +
    '.site-nav__item.submenu-bg-5'
  );

  navItems.forEach(function(item) {
    var itemClasses = Array.from(item.classList);

    var bgClass = itemClasses.find(function(c) { return c.startsWith('submenu-bg-'); });
    var textClass = itemClasses.find(function(c) { return c.startsWith('submenu-text-'); });

    if (!bgClass || !textClass) return;

    // ✔ New logic — "text is light" means the logo gets is-light
    var isTextLight = textClass === 'submenu-text-light';

    var trigger = item.querySelector('.site-nav__details') || item;

    function applyState() {
      clearHeaderClasses();

      header.classList.add(bgClass, textClass);

      // ✔ Apply .is-light to logo ONLY when submenu text color is light
      if (isTextLight && logo) {
        logo.classList.add('is-light');
      }
    }

    function resetState() {
      clearHeaderClasses();
    }

    // Mouse
    trigger.addEventListener('mouseenter', applyState);
    trigger.addEventListener('mouseleave', resetState);

    // Keyboard / accessibility
    trigger.addEventListener('focusin', applyState);
    trigger.addEventListener('focusout', resetState);
  });
});
